
import { getJson, postJson, putJson } from "../ChoiceApi"

import { IRecallSearchInputs, IRecallSearchItem, IRecallSetupResult, IRecallSetupSaveInputs, IRecallSetupSaveResponse } from "../Models/RecallModel";
import { IResponsePassed } from "../Models/ResponseModel";

export const recall = {
    async search(payload: IRecallSearchInputs): Promise<IRecallSearchItem[]> {
        return (await postJson("api/Scheduler/Recall/Search", payload)) as IRecallSearchItem[];
    },
    async setup(recallReminderId: number): Promise<IRecallSetupResult> {
        return (await getJson(`api/Scheduler/Recall/Setup/${recallReminderId}`)) as IRecallSetupResult;
    },
    async save(payload: IRecallSetupSaveInputs): Promise<IRecallSetupSaveResponse> {
        return (await postJson("api/Scheduler/Recall/Save", payload)) as IRecallSetupSaveResponse;
    },
    async cancel(recallReminderId: number): Promise<IResponsePassed> {
        return (await putJson(`api/Scheduler/Recall/Cancel/${recallReminderId}`, null)) as IResponsePassed;
    },
}
